import frontinstance from "./util/front_util";

const frontServer = {
    // 新增首页
    async AddFront(formData){
        try{
            const response = await frontinstance.post("/add", formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response.data;
        }catch(error){
            console.log(error)
        }
    },

    // 修改首页
    async UpdateFront(formData){
        try{
            const response = await frontinstance.put("/image", formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response.data;
        }catch(error){
            throw "修改失败";
        }
    },

    // 获取首页
    async GetFront(){
        try{
            const response = await frontinstance.get("")
            return response.data;
        }catch(error){
            throw "修改失败";
        }
    },

    // 获取商品种类
    async GetFrontType(){
        try{
            const response = await frontinstance.get("/type")
            return response.data; 
        }catch(error){
            throw "修改失败";
        }
    },

    // 删除首页
    async DelFront(Goodsid){
        const response = await frontinstance.delete(`/${Goodsid}`)
        return response.data;
    },

    async GetSubPicture(){
        try{
            const response = await frontinstance.get("/shoe")
            return response.data;
        }catch(error){
            throw "修改失败";
        }
    }

}

export default frontServer